import { render, staticRenderFns } from "./NewConversationDialog.vue?vue&type=template&id=8dbb3d3a&scoped=true"
import script from "./NewConversationDialog.vue?vue&type=script&lang=js"
export * from "./NewConversationDialog.vue?vue&type=script&lang=js"
import style0 from "./NewConversationDialog.vue?vue&type=style&index=0&id=8dbb3d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbb3d3a",
  null
  
)

export default component.exports